import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { hasOAuthParams } from 'app/auth/oauth-params';
import { AuthStateService } from 'app/auth/services/auth-state.service';
import { combineLatest, filter, map } from 'rxjs';
import { LOGIN_PROBLEM_PATH } from './login-problem.guard';

export const allowUnauthenticatedGuard: CanActivateFn = (route) => {
	const authStateService = inject(AuthStateService);
	const router = inject(Router);

	return combineLatest({
		isAuthenticated: toObservable(authStateService.isAuthenticated),
		settled: toObservable(authStateService.isAuthSettled),
	}).pipe(
		filter(({ settled }) => settled),
		map(({ isAuthenticated }) => {
			// E.g. Auth0 refused the sign-in on the way back to the callback, which it reports before auth settles.
			if (authStateService.loginProblem()) {
				return router.parseUrl(LOGIN_PROBLEM_PATH);
			}

			if (!isAuthenticated) {
				return true; // Not authenticated, allow login page
			}

			if (hasOAuthParams(route.queryParamMap)) {
				return true; // Allow OAuth callback to complete
			}

			return router.parseUrl('/main'); // Redirect authenticated users
		})
	);
};
